<template>
 <div class="honour">
  <van-grid :column-num="3" slots="default">
    <van-grid-item v-for="item in list" :key="'list_' + item.id" :to="{name: 'LexusHonourInfo',params:{id:item.id}}">
      <img class="honourpic" :src="img.honour">
      <div class="progressbox">
        <div class="myprogress" :style="{'width':item.progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">{{item.name}}</div>
    </van-grid-item>
    <van-grid-item :to="{name: 'LexusHonourInfo'}">
      <img class="honourpic" :src="img.honour_have">
      <div class="progressbox">
        <div class="myprogress" :style="{'width':progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">职业车手</div>
    </van-grid-item>
    <van-grid-item :to="{name: 'LexusHonourInfo'}">
      <img class="honourpic" :src="img.honour">
      <div class="progressbox">
        <div class="myprogress" :style="{'width':progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">公路传说</div>
    </van-grid-item>
    <van-grid-item :to="{name: 'LexusHonourInfo'}">
      <img class="honourpic" :src="img.honour">
      <div class="progressbox mt-15">
        <div class="myprogress" :style="{'width':progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">业余车手</div>
    </van-grid-item>
    <van-grid-item :to="{name: 'LexusHonourInfo'}">
      <img class="honourpic" :src="img.honour">
      <div class="progressbox">
        <div class="myprogress" :style="{'width':progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">潜力司机</div>
    </van-grid-item>
    <van-grid-item :to="{name: 'LexusHonourInfo'}">
      <img class="honourpic" :src="img.honour_have">
      <div class="progressbox">
        <div class="myprogress" :style="{'width':progress}"></div>
      </div>
      <div class="f-12 mt-5">50/100</div>
      <div class="f-14 f-w mt-15">新手实习</div>
    </van-grid-item>
  </van-grid>
</div>
</template>
<script>
  import common from '../../../api/common';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import {  Grid, GridItem, Image, Icon } from 'vant';
  export default {
    data () {
      return {
        progress:"50%",
        params:{
          source:''
        },
        list:[],
        img:{
          honour: require('../../../assets/img/lexus/my/honour.png'),
          honour_have: require('../../../assets/img/lexus/my/honour_have.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.params.source=this.source
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.getHonor()
      var params={
        event_code: '我的荣耀',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyHonour.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getHonor(){
        member.getHonor(this.params).then(res => {
          this.list=res.data.data.data
        })
      }

    },
    components: {

      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Image.name]:Image,
      [Icon.name]:Icon,

    }
  }
</script>

<style lang="scss">
.honour{
  .mt-15{
    margin-top: 15px;
  }
  .mt-5{
    margin-top: 5px;
  }
  .honourpic{
    width: 56px;
    height: 65px;
  }
  .progressbox{
    width: 90%;
    height: 7px;
    background-color: #F8F8F8;
    border:1px solid #F8F8F8;
    margin-top: 30px;
    .myprogress{
      height: 7px;
      background-color: #605C6B;
    }
  }
}
</style>
